import React from 'react'
import styled from 'styled-components'
import { brandGrey, brandOrange, brandSoftGrey } from '../../../assets/consts/color'
import checkIcon from '../../../assets/images/icon_check.svg'

const Container = styled.div`
  label .label-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;

    cursor: pointer;
  }

  input {
    display: none;
  }

  label div .checkbox-label {
    color: ${brandSoftGrey};
    padding: 0;
    text-transform: capitalize;
  }

  .checkbox-triger {
    position: relative;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border: 1px solid ${brandGrey};
    /* border-radius: 4px; */
    transition:
      background-color 0.25s ease-in-out,
      color 0.25s ease-in-out;

    &:hover {
      border-color: ${brandOrange};
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      width: 10px;
      height: 10px;
      background-color: ${brandOrange};
      /* background-image: url(${checkIcon});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center; */
      opacity: 0;
      transform: translate(-50%, -50%);
      transition:
        opacity 0.25s ease-in-out,
        color 0.25s ease-in-out;
    }
  }

  input:disabled + .label-wrapper {
    cursor: default;
    opacity: 0.5;
  }

  input:checked ~ .label-wrapper .checkbox-triger::after {
    opacity: 1;
  }

  input:checked ~ .label-wrapper .checkbox-triger {
    border-color: ${brandOrange};
    /* background-color: ${brandOrange}; */
  }
`

function CustomizeItem({ name, checked, label, disabled, onChange }) {
  return (
    <Container>
      <label>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <div className="label-wrapper">
          <div className="checkbox-triger" />
          <p className="checkbox-label">{label}</p>
        </div>
      </label>
    </Container>
  )
}

export default CustomizeItem
